import {
    ArrayOfdecimalInput, CommandeModaliteReglementAffichageModel,
    CritereRechercheNumeroPieceDtoInput, EditerLigneCommandeBilletterieArticleGeneriqueGestionModelInput,
    EditerLigneCommandeChangementStatutBilletterieRetourPopupInput,
    EditerLigneCommandeChangementStatutGestionModelInput, EditerLigneCommandeChangementStatutLocationGestionModelInput,
    EnteteDevisCommandeForVentesModeleDto,
    FactureInfosFacturationCommandeClientGestionModelInput, NumeroChoixModelDto,
} from 'src/graphql/generated-types';
import { SoapSchema } from 'src/app/utils/soap-schema-enum';
import { PaymentMode, RouteActivityType } from 'src/app/board/activity/activity.constants';
import { SaleProcess } from 'src/app/board/activity/stores/activity-sales/activity-sales.state';
import { ActivityPrintMailSelection } from 'src/app/_core/services/activity-print-mail.service';
import { SelectedSubventionOrderLine } from 'src/app/board/activity/activity-shared/dialogs/engine-feedback-dialog/engine-feedback-dialog.component';

export type ActivityNewSaleOrderLineStatus = EditerLigneCommandeChangementStatutGestionModelInput
    | EditerLigneCommandeChangementStatutBilletterieRetourPopupInput
    | EditerLigneCommandeChangementStatutLocationGestionModelInput;

export type ActivityNewSaleOrderLine = EditerLigneCommandeBilletterieArticleGeneriqueGestionModelInput

interface InfosFacturationCommandeClientGestionModelInputXml extends FactureInfosFacturationCommandeClientGestionModelInput {
    schema: SoapSchema;

    InfosCheque: {
        schema: SoapSchema,
        type: string,
        NomBanque: string,
        NumeroCheque: string
        TitreCheque: string
    };

    InfosMoyenPaiement: {
        schema: SoapSchema,
        type: string,
        IdMoyenPaiement: number
    };

    ListeIdCommande: {
        schema: SoapSchema
    } & ArrayOfdecimalInput;

}

const stateName = '[ActivitySales] ';

// <editor-fold defaultstate="collapsed" desc="Initialization">

export class IgnoreKeepDialogAction {
    static readonly type = stateName + 'setIgnoreKeepDialog';

    constructor(public ignoreKeepDialog: boolean = false) {
    }
}

export class ActivityInitializeSalesAction {
    static readonly type = stateName + 'initializeSale';

    constructor(public params: {activityType: RouteActivityType, productId?: number, articleId?: number}) {
    }
}

export class ActivitySetActivityIdAction {
    static readonly type = stateName + 'SetActivityId';

    constructor(public activityId: number) {
    }
}

export class ActivityInitializeSaleByIdOrderAction {
    static readonly type = stateName + 'initializeSaleByIdOrder';

    constructor(public orderId: number, public activityId: number) {
    }
}

export class ActivityGetActivityTypeCodeFromActivityIdAction {
    static readonly type = stateName + 'ActivityGetActivityTypeCodeFromActivityId';

    constructor(public activityId: number) {
    }
}

// </editor-fold>

// <editor-fold defaultstate="collapsed" desc="DeliveryModes">

export class ActivityGetDeliveryModesListAction {
    static readonly type = stateName + 'GetDeliveryModesList';
}

// </editor-fold>

// <editor-fold defaultstate="collapsed" desc="Edit | Update Sale">

export class UpdateDevisBenefAction {
    static readonly type = stateName + 'UpdateDevisBenef';

    constructor(public idBeneficiary: number, public orderId: number) {
    }
}

export class ActivityDeleteSaleAction {
    static readonly type = stateName + 'deleteSale';
}

export class ActivityUpdateOrderHeaderAction {
    static readonly type = stateName + 'updateOrderHeader';

    constructor(public header?: EnteteDevisCommandeForVentesModeleDto) {
    }
}

// </editor-fold>

// <editor-fold defaultstate="collapsed" desc="Order line action">

export class ActivityAddOrUpdateOrderLineAction {
    static readonly type = stateName + 'addOrderLine';

    constructor(public params: {
        article: SelectedSubventionOrderLine,
        isEngineFeedback?: boolean,
        activityType: RouteActivityType
    }) {
    }
}

export class ActivityCancelEngineFeebackOnOrderLineAction {
    static readonly type = stateName + 'CancelEngineFeebackOnOrderLine';
}

export class ActivityUpdateOrderLineStatusAction {
    static readonly type = stateName + 'UpdateOrderLineStatus';

    constructor(public params: {
        orderLine: ActivityNewSaleOrderLineStatus,
        isEngineFeedback: boolean,
        activityType: RouteActivityType
    }) {
    }
}

export class ActivityDeleteOrderLineAction {
    static readonly type = stateName + 'DeleteOrderLine';

    constructor(public lineId: number) {
    }
}

export class ActivityClearOrderLinesListAction {
    static readonly type = stateName + 'ActivityClearOrderLinesList';
}

export class ActivityUpdateSettlementPreferenceAction {
    static readonly type = stateName + 'ActivityUpdateSettlementPreference';

    constructor(public settlementPreference: CommandeModaliteReglementAffichageModel) {
    }
}

export class ActivityUpdateChoicesSessionsAction {
    static readonly type = stateName + 'UpdateChoicesSessions';

    constructor(public choiceSession: NumeroChoixModelDto) {
    }
}

export class ActivityCheckSettlementPreferenceAction {
    static readonly type = stateName + 'CheckSettlementPreference';

    constructor(public params: {
        activityType: RouteActivityType,
        orderId: number
    }) {
    }
}

// </editor-fold>

// <editor-fold defaultstate="collapsed" desc="FPA">

export class ActivitySetArticlesCountAction {
    static readonly type = stateName + 'ActivitySetArticlesCount';

    constructor(public count = 0) {
    }
}

export class ActivityGetFamiliesListAction {
    static readonly type = stateName + 'GetFamiliesList';

    constructor(public activityId?: number) {
    }
}

export class ActivityGetProductsListAction {
    static readonly type = stateName + 'GetProductsList';

    constructor(public familyId?: number) {
    }
}

// </editor-fold>

// <editor-fold defaultstate="collapsed" desc="Filters">

export class ActivityToggleFiltersAction {
    static readonly type = stateName + 'toggleFilters';

    constructor(public isOpenedFilters?: boolean) {
    }
}

export class ActivitySetFiltersAction {
    static readonly type = stateName + 'SetFilters';

    constructor(public filters?: any) {
    }
}

// </editor-fold>

// <editor-fold defaultstate="collapsed" desc="End sale">

export class ActivitySalesPrepareOrderAction {
    static readonly type = stateName + 'PrepareOrder';
}

export class ActivitySalesSetPaymentMethodAction {
    static readonly type = stateName + 'SetPaymentMethod';

    constructor(public payload: { paymentMethodId?: number, paymentMode?: PaymentMode } = {
        paymentMethodId: null,
        paymentMode: PaymentMode.None
    }) {
    }
}

export class FinalizeOrderAction {
    static readonly type = stateName + 'finalizeOrder';

    constructor(public infosBilling: FactureInfosFacturationCommandeClientGestionModelInput | InfosFacturationCommandeClientGestionModelInputXml) {
    }
}

export class ActivitySalesChangeProcessAction {
    static readonly type = stateName + 'ChangeProcess';

    constructor(public process: SaleProcess) {
    }
}

// </editor-fold>

// <editor-fold defaultstate="collapsed" desc="Sales deposits list action">

export class ActivitySalesGetDepositsListAction {
    static readonly type = stateName + 'GetDepositsList';
    constructor(public orderId?: number) {
    }
}

export class ActivitySalesResetDepositsListAction {
    static readonly type = stateName + 'ResetDepositsList';
}

export class ActivitySalesCanDeleteDepositAction {
    static readonly type = stateName + 'CanDeleteDeposit';

    constructor(public depositId: number) {
    }
}

export class ActivitySalesDeleteDepositAction {
    static readonly type = stateName + 'DeleteDeposit';

    constructor(public depositId: number) {
    }
}

// </editor-fold>

// <editor-fold defaultstate="collapsed" desc="Reset state">

export class ResetActivitySalesStateAction {
    static readonly type = stateName + 'ResetActivitySalesState';
}

// </editor-fold>

export class GetLastWritingAccountNumberAction {
    static readonly type = stateName + 'GetLastWritingAccountNumber';

    constructor(public criteres: CritereRechercheNumeroPieceDtoInput) {
    }
}

// <editor-fold default-state="collapsed" desc="Has prints">

export class SetPrintsAndMailsActivitySalesAction {
    static readonly type = stateName + 'SetHasPrintsActivitySales';

    constructor(public options: {
        mailOptions?: ActivityPrintMailSelection,
        printOptions?: ActivityPrintMailSelection
    }) {
    }
}

// </editor-fold>
